import { QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { FormValidatorBuilder } from '../../../../../validator/form-builder/FormValidatorBuilder';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope';
import { tran } from '../../../../translations/schema/TranslationSchema';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import type { IQuestionWidget } from './IQuestionWidget';
import { QuestionWidgetComponent } from './QuestionWidgetComponent';
import {
  QuestionWidgetConfigComponent,
  QuestionWidgetConfigSchema,
} from './QuestionWidgetConfigComponent';

/**
 * Tipo del Widget "Quesito"
 */
export const QuestionWidgetType: IWidgetType<IQuestionWidget> = {
  type: WidgetType.Question,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Container,
  name: 'Quesito',
  icon: <QuestionCircleOutlined />,
  hasValue: false,
  formComponent: QuestionWidgetComponent,
  createFormSchema: ({ widget, section, page, parentScope }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);
    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  },
  configComponent: QuestionWidgetConfigComponent,
  configValidator: QuestionWidgetConfigSchema,
  previewComponent: QuestionWidgetComponent,
  translationSchema: tran.widget({
    title: tran.rte(),
    helpText: tran.rte(),
    description: tran.rte(),
  }),
  rules: [],
};
